<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2 class="mb-2">{{ $t('Log In') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active">{{ $t('Log In') }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- log in section start -->
        <section class="log-in-section background-image-2 section-b-space">
            <div class="container-fluid-lg w-100">
                <div class="row">
                    <div class="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                        <div class="image-contain">
                            <img src="/theme/assets/images/inner-page/log-in.png" class="img-fluid" alt="">
                        </div>
                    </div>

                    <div class="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                        <div class="log-in-box">
                            <div class="log-in-title">
                                <h3> {{ $t('Welcome To') }} {{ main?.settings?.name }}</h3>
                                <h4>{{ $t('Log In Your Account')}}</h4>
                            </div>


                            <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" :class="{ 'show' : error !== null }" role="alert">
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                <strong>{{error}}</strong>
                            </div>


                            <div class="input-box">
                                <form class="row g-4" @submit.prevent="login()">
<!--                                    <div class="col-12">-->
<!--                                        <div class="form-floating theme-form-floating log-in-form">-->
<!--                                            <input type="tel" class="form-control pe-1" id="login-mobile" placeholder="5×××××"-->
<!--                                                   aria-label="phone" aria-describedby="phone" v-model="user.mobile" dir="ltr">-->

<!--                                            <label for="login-mobile">{{ $t('Phone number') }}</label>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="text" class="form-control pe-1" id="login-identifier" placeholder="Email or Phone"
                                                   aria-label="identifier" aria-describedby="identifier" v-model="user.identifier" dir="ltr">
                                            <label for="login-identifier">{{ $t('Email or Phone') }}</label>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">

                                            <input type="password" class="form-control pe-1" id="login-password"
                                                   aria-label="password" aria-describedby="password"  v-model="user.password" autocomplete="password">

                                            <label for="login-password">{{ $t('Password')}}</label>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="forgot-box">
<!--                                            <div class="form-check ps-0 m-0 remember-box">-->
<!--                                                <input class="checkbox_animated check-box" type="checkbox"-->
<!--                                                       id="flexCheckDefault">-->
<!--                                                <label class="form-check-label" for="flexCheckDefault">Remember me</label>-->
<!--                                            </div>-->
                                            <router-link :to="{ name:'password.reset' , params: { lang : $i18n.locale }}"  class="forgot-password">
                                                {{  $t('Forgot Password?') }}
                                            </router-link>

                                        </div>
                                    </div>
                                    <div class="col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="remember" id="remember" v-model="user.remember">

                                        <label class="form-check-label" for="remember">
                                            {{ $t('Remember Me') }}
                                        </label>
                                    </div>
                                    </div>


                                    <div class="col-12">
                                        <button class="btn btn-animation w-100 justify-content-center" type="submit">
                                            {{ $t('Log In') }}
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div class="other-log-in">
                                <h6></h6>
                            </div>

                            <div class="sign-up-box">
                                <h4>{{ $t('Don\'t have an account?')}}</h4>
                                <router-link :to="{ name:'register' , params: { lang : $i18n.locale }}" >{{ $t('Sign Up')}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- log in section end -->
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    props :['main'],
    data() {
        return {
            user: {},
            error: null,
        }
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === true){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    methods: {
        login() {
            const  that = this;

            const id = toast.success(this.$t('Signing in.'), {
                timeout: 2000
            });

            this.auth.login({
                'data' : this.user,
                'on_success' : function (response){
                    toast.success(this.$t('Welcome back again.'), {
                        timeout: 2000
                    });
                    // that.error = null;
                    // that.$router.push({name: 'home'});
                },
                'on_fail' : function (message){
                    that.error = message;
                },
                'on_completed' : function (){
                    toast.dismiss(id);
                }
            });

        }
    },
}
</script>
